import React, { FC, useEffect, useRef, useState } from "react";
import { Button, Icon, Input } from "@metsooutotec/modes-react-components";

interface TableFilterBoxProps {
    onSearch: (value: string) => void;
    isLast: boolean;
}
const TableFilterBox: FC<TableFilterBoxProps> = ({ onSearch, isLast }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>();
    const ref = useRef<HTMLDivElement>(null);
    const handleClickOutside = (event: Event) => {
        if (ref.current && !ref.current?.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const onInputChange = (value:string) => {
        onSearch(value);
        setInputValue(value);
    }
    const onClearClick = () => {
        onInputChange("");
    }
    const icons =
        <>
            {inputValue && (
                <Icon className="icon-cross-circle-fill-16" onClick={() => onClearClick()} />
            )}
            <Icon className="icon-search-16" />  
        </>
        ;
    return (
        <div ref={ref} className="table-filter-box">
            <div className="table-filter-buttonDiv" >
            <Button
                size="small"
                icon="icon-search-16"
                onClick={() => setIsOpen(!isOpen)}
                style={{ backgroundColor: 'transparent' }}
                />
                {inputValue && inputValue.trim() !== '' && (
                    <span className="table-filter-starDiv">
                        *
                    </span>
                )}
            </div>
            {isOpen && (
                <div className={`table-filter-inputDiv ${isLast ? 'right-0' : 'right-auto'}` }>
                    <Input
                        placeholder="Search..."
                        onChange={(e) => onInputChange(e.target.value)}
                        icon={icons}
                        value={inputValue}
                        heightClass="small"
                        autoFocus
                    />
                </div>
            )}
        </div>
    );
}

export default TableFilterBox;